export const sendBillTransactionConstants = {
    GET_SEND_BILL_TRANSACTION_REQUEST: 'GET_SEND_BILL_TRANSACTION_REQUEST',
    GET_SEND_BILL_TRANSACTION_SUCCESS: 'GET_SEND_BILL_TRANSACTION_SUCCESS',
    GET_SEND_BILL_TRANSACTION_FAIL: 'GET_SEND_BILL_TRANSACTION_FAIL',
}